import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { DetailTable, Detail } from "MODULES/shared/components/DetailTable";
import pojo from "LIB/pojos";
import { shortDate } from "LIB/formatters/date";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import { ACCOUNTING } from "MODULES/users/constants";
import Section from "MODULES/shared/components/Section";
import {
  INVENTORY,
  PURCHASED_FOR_EXCHANGE_ID
} from "MODULES/inventories/constants";
import withPurchaseOrder from "MODULES/PurchaseOrders/decorators/withPurchaseOrder";
import {
  ASSIGNED_CORE_RETURN_ID,
  VENDOR_CORE_REPAIR_INVOICE_AMOUNT_PAID,
  VENDOR_CORE_REPAIR_INVOICE_DUE_DATE,
  VENDOR_CORE_REPAIR_INVOICE_NUMBER,
  VENDOR_CORE_REPAIR_INVOICE_PAID
} from "MODULES/PurchaseOrders/constants";
import { hasRole } from "MODULES/users/helpers";
import { LINE_ITEMS } from "APP_ROOT/constants";
import { purchaseOrderLastExchange } from "MODULES/PurchaseOrders/shared/helpers";
import Form from "./Form";

export function Billing({ purchaseOrder, currentUser }) {
  const hasPurchaseExchange = purchaseOrder.getIn([
    INVENTORY,
    PURCHASED_FOR_EXCHANGE_ID
  ]);

  const hasAssignedCore = purchaseOrder
    .getIn([LINE_ITEMS, 0])
    .get(ASSIGNED_CORE_RETURN_ID);

  return (
    <Section
      title="Vendor Core Repair"
      modal={{
        title: "Edit Vendor Core Repair Billing Details",
        content: close => (
          <Form
            close={close}
            hasAssignedCore={hasAssignedCore}
            hasPurchaseExchange={hasPurchaseExchange}
            initialValues={pojo(purchaseOrder.toJS()).pick(
              VENDOR_CORE_REPAIR_INVOICE_NUMBER,
              VENDOR_CORE_REPAIR_INVOICE_PAID,
              VENDOR_CORE_REPAIR_INVOICE_DUE_DATE,
              VENDOR_CORE_REPAIR_INVOICE_AMOUNT_PAID
            )}
            isLastExchange={purchaseOrderLastExchange(purchaseOrder.toJS())}
          />
        )
      }}
      editable={hasRole(currentUser, ACCOUNTING)}
    >
      <DetailTable>
        <Detail
          label="Repair Inv. #"
          value={purchaseOrder.get(VENDOR_CORE_REPAIR_INVOICE_NUMBER)}
        />
        <Detail
          label="Repair Inv. Pd Date"
          value={shortDate(purchaseOrder.get(VENDOR_CORE_REPAIR_INVOICE_PAID))}
        />
      </DetailTable>
    </Section>
  );
}

Billing.propTypes = {
  purchaseOrder: T.instanceOf(Map).isRequired,
  ...WithCurrentUser
};

export default withCurrentUser(withPurchaseOrder(Billing));



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/Billing/Billing.jsx